// Code generated by csilgen. DO NOT EDIT.
// Source: <csil spec>
// Target: typescript-codec

import type { AccessLevel, ApproveCliLoginRequest, AuditEntry, AuditID, AuditPage, AuditQuery, BeginCliLoginRequest, BeginCliLoginResponse, BoolResponse, BugReportRequest, CalendarSubscription, CalendarView, CliLoginRequestInfo, CliLoginStatus, CliSessionID, CliSessionSummary, CliSessionsResponse, CliTokenResponse, Comment, CommentID, CommentListRequest, CompleteRequest, DenyCliLoginRequest, DependencyGraph, DependencyNode, DependencyNodeType, DependencyRef, DependencyTarget, DevLoginRequest, DevUserEntry, DevUsersResponse, EffectiveSettings, EmptyRequest, EmptyResponse, Event, EventID, EventListRequest, ExchangeCliLoginRequest, ExchangeCliLoginResponse, Grant, GranteeType, Group, GroupID, GroupMember, GroupMemberRef, GroupSkill, GroupSkillRef, House, HouseID, HouseListRequest, HouseRoles, HouseScopedListRequest, HouseSummary, Identity, LoginRequest, LoginResponse, MeResponse, Member, MemberAudit, MemberAuditID, MemberID, MemberRole, MemberRoleRef, MemberScopedListRequest, MemberSkill, MemberSkillRef, Milestone, MilestoneID, MilestoneState, Notification, NotificationID, NotificationListRequest, NotificationUnreadCount, Project, ProjectGrantRef, ProjectID, ProjectList, ProjectMember, ProjectMemberRef, ProjectOwner, ProjectOwnerRef, ProjectScopedListRequest, ProjectStatus, ProjectTask, ProjectTaskOrderRequest, ProjectTaskRef, PurgeRequest, PutProjectGrantRequest, PutTaskGrantRequest, RecurrenceFreq, RefreshSessionRequest, ResourceRef, ResourceType, RestoreRequest, RevokeSessionRequest, Role, RoleID, ServiceError, SessionKind, SetProjectVisibilityRequest, SetTaskVisibilityRequest, Share, ShareAccessRequest, ShareID, Skill, SkillID, TargetType, Task, TaskGrantRef, TaskID, TaskList, TaskListRequest, TaskState, TaskStatus, Timestamp, TrashItem, TrashPage, TrustedDomain, TrustedDomainID, UpdateSettingsRequest } from "./types.gen";

/** A CBOR semantic tag wrapping an inner value (e.g. tag 0 timestamp, tag 4 decimal). */
export type CborTag = { readonly tag: number; readonly value: CborValue };

/** A minimal canonical-CBOR value tree: a closed set of node variants. */
export type CborValue =
  | number
  | bigint
  | boolean
  | null
  | string
  | Uint8Array
  | CborValue[]
  | Map<CborValue, CborValue>
  | CborTag;

const csilTextEncoder = new TextEncoder();
const csilTextDecoder = new TextDecoder("utf-8", { fatal: true });

function head(major: number, n: number | bigint, out: number[]): void {
  const mt = major << 5;
  const big = typeof n === "bigint" ? n : BigInt(n);
  if (big < 24n) {
    out.push(mt | Number(big));
  } else if (big < 0x100n) {
    out.push(mt | 24, Number(big) & 0xff);
  } else if (big < 0x10000n) {
    out.push(mt | 25, Number((big >> 8n) & 0xffn), Number(big & 0xffn));
  } else if (big < 0x100000000n) {
    out.push(mt | 26);
    for (let s = 24n; s >= 0n; s -= 8n) out.push(Number((big >> s) & 0xffn));
  } else {
    out.push(mt | 27);
    for (let s = 56n; s >= 0n; s -= 8n) out.push(Number((big >> s) & 0xffn));
  }
}

function encInt(n: bigint, out: number[]): void {
  if (n >= 0n) head(0, n, out);
  else head(1, -1n - n, out);
}

function encFloat(d: number, out: number[]): void {
  out.push(0xfb);
  const view = new DataView(new ArrayBuffer(8));
  view.setFloat64(0, d, false);
  for (let i = 0; i < 8; i++) out.push(view.getUint8(i));
}

function encInto(v: CborValue, out: number[]): void {
  if (typeof v === "number") {
    if (Number.isInteger(v)) encInt(BigInt(v), out);
    else encFloat(v, out);
  } else if (typeof v === "bigint") {
    encInt(v, out);
  } else if (typeof v === "boolean") {
    out.push(v ? 0xf5 : 0xf4);
  } else if (v === null) {
    out.push(0xf6);
  } else if (typeof v === "string") {
    const bytes = csilTextEncoder.encode(v);
    head(3, bytes.length, out);
    for (const b of bytes) out.push(b);
  } else if (v instanceof Uint8Array) {
    head(2, v.length, out);
    for (const b of v) out.push(b);
  } else if (Array.isArray(v)) {
    head(4, v.length, out);
    for (const x of v) encInto(x, out);
  } else if (v instanceof Map) {
    head(5, v.size, out);
    for (const [k, val] of v) {
      encInto(k, out);
      encInto(val, out);
    }
  } else {
    head(6, v.tag, out);
    encInto(v.value, out);
  }
}

/** Encode a CBOR value tree to canonical CSIL CBOR bytes. */
export function encodeValue(value: CborValue): Uint8Array {
  const out: number[] = [];
  encInto(value, out);
  return Uint8Array.from(out);
}

type Cursor = { b: Uint8Array; pos: number };

function readArg(st: Cursor, low: number): bigint {
  if (low < 24) {
    st.pos += 1;
    return BigInt(low);
  }
  const width = low === 24 ? 1 : low === 25 ? 2 : low === 26 ? 4 : low === 27 ? 8 : 0;
  if (width === 0 || st.pos >= st.b.length || st.b.length - st.pos - 1 < width) {
    throw new Error("truncated CBOR argument");
  }
  if (low === 24) {
    const v = BigInt(st.b[st.pos + 1]);
    st.pos += 2;
    return v;
  }
  if (low === 25) {
    let v = 0n;
    for (let i = 1; i <= 2; i++) v = (v << 8n) | BigInt(st.b[st.pos + i]);
    st.pos += 3;
    return v;
  }
  if (low === 26) {
    let v = 0n;
    for (let i = 1; i <= 4; i++) v = (v << 8n) | BigInt(st.b[st.pos + i]);
    st.pos += 5;
    return v;
  }
  if (low === 27) {
    let v = 0n;
    for (let i = 1; i <= 8; i++) v = (v << 8n) | BigInt(st.b[st.pos + i]);
    st.pos += 9;
    return v;
  }
  throw new Error("malformed CBOR argument");
}

function smallInt(arg: bigint): number | bigint {
  return arg <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(arg) : arg;
}

function readFloat(st: Cursor, low: number): number {
  const bits = readArg(st, low);
  if (low === 26) {
    const view = new DataView(new ArrayBuffer(4));
    view.setUint32(0, Number(bits), false);
    return view.getFloat32(0, false);
  }
  const view = new DataView(new ArrayBuffer(8));
  view.setBigUint64(0, bits, false);
  return view.getFloat64(0, false);
}

function decInto(st: Cursor, depth: number): CborValue {
  if (depth > 64) throw new Error("CBOR nesting limit exceeded");
  if (st.pos >= st.b.length) throw new Error("unexpected end of CBOR input");
  const ib = st.b[st.pos];
  const major = ib >> 5;
  const low = ib & 0x1f;
  if (major === 7) {
    if (low === 20) {
      st.pos += 1;
      return false;
    }
    if (low === 21) {
      st.pos += 1;
      return true;
    }
    if (low === 22 || low === 23) {
      st.pos += 1;
      return null;
    }
    if (low === 26 || low === 27) return readFloat(st, low);
    throw new Error("malformed CBOR simple value");
  }
  const arg = readArg(st, low);
  switch (major) {
    case 0:
      return smallInt(arg);
    case 1: {
      const n = -1n - arg;
      return n >= BigInt(Number.MIN_SAFE_INTEGER) ? Number(n) : n;
    }
    case 2: {
      if (arg > BigInt(st.b.length - st.pos)) throw new Error("truncated CBOR byte string");
      const n = Number(arg);
      const slice = st.b.slice(st.pos, st.pos + n);
      st.pos += n;
      return slice;
    }
    case 3: {
      if (arg > BigInt(st.b.length - st.pos)) throw new Error("truncated CBOR text string");
      const n = Number(arg);
      const text = csilTextDecoder.decode(st.b.subarray(st.pos, st.pos + n));
      st.pos += n;
      return text;
    }
    case 4: {
      if (arg > BigInt(st.b.length - st.pos)) throw new Error("CBOR array length exceeds remaining input");
      const n = Number(arg);
      const arr: CborValue[] = [];
      for (let i = 0; i < n; i++) arr.push(decInto(st, depth + 1));
      return arr;
    }
    case 5: {
      if (arg > BigInt(st.b.length - st.pos)) throw new Error("CBOR map length exceeds remaining input");
      const n = Number(arg);
      const m = new Map<CborValue, CborValue>();
      for (let i = 0; i < n; i++) {
        const k = decInto(st, depth + 1);
        const val = decInto(st, depth + 1);
        m.set(k, val);
      }
      return m;
    }
    case 6: {
      const inner = decInto(st, depth + 1);
      return { tag: Number(arg), value: inner };
    }
    default:
      throw new Error("malformed CBOR major type");
  }
}

/** Decode a CSIL CBOR byte payload into a CBOR value tree. */
export function decode(bytes: Uint8Array): CborValue {
  const st: Cursor = { b: bytes, pos: 0 };
  const v = decInto(st, 0);
  if (st.pos !== bytes.length) throw new Error("trailing bytes after CBOR value");
  return v;
}

/** The value for `key` in a CBOR map node, or `undefined` when absent. */
export function mapGet(value: CborValue, key: string): CborValue | undefined {
  return value instanceof Map ? value.get(key) : undefined;
}

/** The value for a required `key`; throws when the field is missing. */
export function requireKey(value: CborValue, key: string): CborValue {
  const v = mapGet(value, key);
  if (v === undefined) throw new Error(`missing required field: ${key}`);
  return v;
}

export function asNumber(value: CborValue): number {
  if (typeof value === "number") return value;
  if (typeof value === "bigint") return Number(value);
  throw new Error("expected a number");
}

export function asString(value: CborValue): string {
  if (typeof value === "string") return value;
  throw new Error("expected a text string");
}

export function asBytes(value: CborValue): Uint8Array {
  if (value instanceof Uint8Array) return value;
  throw new Error("expected a byte string");
}

export function asBool(value: CborValue): boolean {
  if (typeof value === "boolean") return value;
  throw new Error("expected a boolean");
}

export function asArray(value: CborValue): CborValue[] {
  if (Array.isArray(value)) return value;
  throw new Error("expected an array");
}

export function asMap(value: CborValue): Map<CborValue, CborValue> {
  if (value instanceof Map) return value;
  throw new Error("expected a map");
}

/** A decoded integer may surface as `bigint` (see `decInto`'s large-value path), so a
 * numeric literal's expected `number` is compared against the `bigint`-normalized form
 * rather than failing on a type mismatch that isn't a value mismatch. */
export function asLiteral<T extends CborValue>(value: CborValue, expected: T): T {
  const norm = typeof value === "bigint" && typeof expected === "number" ? Number(value) : value;
  if (norm !== expected) throw new Error(`literal mismatch: expected ${JSON.stringify(expected)}`);
  return expected;
}

/** Validate a decoded scalar against a literal-enum's declared vocabulary, erroring
 * on an unknown value. The caller reads through `asNumber`/`asString`/`asBool`, which
 * already normalize a decoded `bigint` to `number`, so a plain membership check suffices. */
export function asEnumMember<T extends number | string | boolean | null>(
  value: T,
  members: readonly T[],
): T {
  if (!members.includes(value)) {
    throw new Error(`unknown enum value: ${JSON.stringify(value)}`);
  }
  return value;
}

/** Read a decoded CBOR scalar without narrowing to one JS type, normalizing a
 * decoded integer `bigint` to `number` the same way `asNumber` does. Used for a
 * MIXED-kind literal enum (`"a" / 1`), where no single `asNumber`/`asString`/
 * `asBool` reader fits every member's runtime type — `asEnumMember`'s membership
 * check does the real narrowing instead. */
export function asEnumScalar(value: CborValue): string | number | boolean | null {
  if (typeof value === "bigint") return Number(value);
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean" ||
    value === null
  ) {
    return value;
  }
  throw new Error("expected an enum scalar (string, number, boolean, or null)");
}

function asTagged(value: CborValue, tag: number): CborValue {
  if (
    typeof value === "object" &&
    value !== null &&
    !Array.isArray(value) &&
    !(value instanceof Uint8Array) &&
    !(value instanceof Map) &&
    value.tag === tag
  ) {
    return value.value;
  }
  throw new Error(`expected tag ${tag}`);
}

/** Decode a tag-0 (RFC 3339, UTC) timestamp into a `Date`. */
export function asTimestamp(value: CborValue): Date {
  return new Date(asString(asTagged(value, 0)));
}

/** Decode a tag-4 decimal fraction into its `[exponent, mantissa]` payload. */
export function asDecimalPayload(value: CborValue): [number | bigint, number | bigint] {
  const arr = asArray(asTagged(value, 4));
  const intOf = (x: CborValue): number | bigint => {
    if (typeof x === "number" || typeof x === "bigint") return x;
    throw new Error("expected an integer in decimal payload");
  };
  return [intOf(arr[0]), intOf(arr[1])];
}

/** A `Date` rendered as the canonical tag-0 text: RFC 3339, UTC, `Z` offset. */
export function csilTsToText(d: Date): string {
  return d.toISOString().replace(/\.000Z$/, "Z");
}

export function toHouseCborValue(v: House): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("name", v.name);
  csilMap.set("house_id", v.houseId);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("updated_at", v.updatedAt);
  if (v.description !== undefined) csilMap.set("description", v.description);
  return csilMap;
}

export function fromHouseCborValue(value: CborValue): House {
  return {
    houseId: asString(requireKey(value, "house_id")),
    name: asString(requireKey(value, "name")),
    description: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "description")),
    createdAt: asString(requireKey(value, "created_at")),
    updatedAt: asString(requireKey(value, "updated_at")),
  };
}

export function toHouseCbor(v: House): Uint8Array {
  return encodeValue(toHouseCborValue(v));
}

export function fromHouseCbor(bytes: Uint8Array): House {
  return fromHouseCborValue(decode(bytes));
}

export function toMemberCborValue(v: Member): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.email !== undefined) csilMap.set("email", v.email);
  if (v.handle !== undefined) csilMap.set("handle", v.handle);
  csilMap.set("house_id", v.houseId);
  csilMap.set("member_id", v.memberId);
  if (v.avatarUrl !== undefined) csilMap.set("avatar_url", v.avatarUrl);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("updated_at", v.updatedAt);
  if (v.displayName !== undefined) csilMap.set("display_name", v.displayName);
  if (v.lastSeenAt !== undefined) csilMap.set("last_seen_at", v.lastSeenAt);
  if (v.deactivatedAt !== undefined) csilMap.set("deactivated_at", v.deactivatedAt);
  csilMap.set("linkkeys_domain", v.linkkeysDomain);
  csilMap.set("linkkeys_user_id", v.linkkeysUserId);
  if (v.cachedPublicKey !== undefined) csilMap.set("cached_public_key", v.cachedPublicKey);
  return csilMap;
}

export function fromMemberCborValue(value: CborValue): Member {
  return {
    memberId: asString(requireKey(value, "member_id")),
    houseId: asString(requireKey(value, "house_id")),
    linkkeysDomain: asString(requireKey(value, "linkkeys_domain")),
    linkkeysUserId: asString(requireKey(value, "linkkeys_user_id")),
    displayName: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "display_name")),
    email: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "email")),
    avatarUrl: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "avatar_url")),
    handle: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "handle")),
    cachedPublicKey: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asBytes(csilV))(mapGet(value, "cached_public_key")),
    createdAt: asString(requireKey(value, "created_at")),
    updatedAt: asString(requireKey(value, "updated_at")),
    lastSeenAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "last_seen_at")),
    deactivatedAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "deactivated_at")),
  };
}

export function toMemberCbor(v: Member): Uint8Array {
  return encodeValue(toMemberCborValue(v));
}

export function fromMemberCbor(bytes: Uint8Array): Member {
  return fromMemberCborValue(decode(bytes));
}

export function toTrustedDomainCborValue(v: TrustedDomain): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("domain", v.domain);
  csilMap.set("house_id", v.houseId);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("trusted_domain_id", v.trustedDomainId);
  return csilMap;
}

export function fromTrustedDomainCborValue(value: CborValue): TrustedDomain {
  return {
    trustedDomainId: asString(requireKey(value, "trusted_domain_id")),
    houseId: asString(requireKey(value, "house_id")),
    domain: asString(requireKey(value, "domain")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toTrustedDomainCbor(v: TrustedDomain): Uint8Array {
  return encodeValue(toTrustedDomainCborValue(v));
}

export function fromTrustedDomainCbor(bytes: Uint8Array): TrustedDomain {
  return fromTrustedDomainCborValue(decode(bytes));
}

export function toRoleCborValue(v: Role): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("name", v.name);
  csilMap.set("role_id", v.roleId);
  csilMap.set("house_id", v.houseId);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("updated_at", v.updatedAt);
  if (v.description !== undefined) csilMap.set("description", v.description);
  return csilMap;
}

export function fromRoleCborValue(value: CborValue): Role {
  return {
    roleId: asString(requireKey(value, "role_id")),
    houseId: asString(requireKey(value, "house_id")),
    name: asString(requireKey(value, "name")),
    description: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "description")),
    createdAt: asString(requireKey(value, "created_at")),
    updatedAt: asString(requireKey(value, "updated_at")),
  };
}

export function toRoleCbor(v: Role): Uint8Array {
  return encodeValue(toRoleCborValue(v));
}

export function fromRoleCbor(bytes: Uint8Array): Role {
  return fromRoleCborValue(decode(bytes));
}

export function toMemberRoleCborValue(v: MemberRole): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("role_id", v.roleId);
  csilMap.set("member_id", v.memberId);
  csilMap.set("created_at", v.createdAt);
  return csilMap;
}

export function fromMemberRoleCborValue(value: CborValue): MemberRole {
  return {
    memberId: asString(requireKey(value, "member_id")),
    roleId: asString(requireKey(value, "role_id")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toMemberRoleCbor(v: MemberRole): Uint8Array {
  return encodeValue(toMemberRoleCborValue(v));
}

export function fromMemberRoleCbor(bytes: Uint8Array): MemberRole {
  return fromMemberRoleCborValue(decode(bytes));
}

export function toMemberAuditCborValue(v: MemberAudit): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("action", v.action);
  if (v.detail !== undefined) csilMap.set("detail", v.detail);
  csilMap.set("audit_id", v.auditId);
  csilMap.set("house_id", v.houseId);
  if (v.targetId !== undefined) csilMap.set("target_id", v.targetId);
  csilMap.set("created_at", v.createdAt);
  if (v.targetType !== undefined) csilMap.set("target_type", v.targetType);
  if (v.actorMemberId !== undefined) csilMap.set("actor_member_id", v.actorMemberId);
  csilMap.set("subject_member_id", v.subjectMemberId);
  return csilMap;
}

export function fromMemberAuditCborValue(value: CborValue): MemberAudit {
  return {
    auditId: asString(requireKey(value, "audit_id")),
    houseId: asString(requireKey(value, "house_id")),
    subjectMemberId: asString(requireKey(value, "subject_member_id")),
    actorMemberId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "actor_member_id")),
    action: asString(requireKey(value, "action")),
    targetType: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "target_type")),
    targetId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "target_id")),
    detail: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "detail")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toMemberAuditCbor(v: MemberAudit): Uint8Array {
  return encodeValue(toMemberAuditCborValue(v));
}

export function fromMemberAuditCbor(bytes: Uint8Array): MemberAudit {
  return fromMemberAuditCborValue(decode(bytes));
}

export function toSkillCborValue(v: Skill): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("name", v.name);
  csilMap.set("house_id", v.houseId);
  csilMap.set("skill_id", v.skillId);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("updated_at", v.updatedAt);
  if (v.description !== undefined) csilMap.set("description", v.description);
  return csilMap;
}

export function fromSkillCborValue(value: CborValue): Skill {
  return {
    skillId: asString(requireKey(value, "skill_id")),
    houseId: asString(requireKey(value, "house_id")),
    name: asString(requireKey(value, "name")),
    description: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "description")),
    createdAt: asString(requireKey(value, "created_at")),
    updatedAt: asString(requireKey(value, "updated_at")),
  };
}

export function toSkillCbor(v: Skill): Uint8Array {
  return encodeValue(toSkillCborValue(v));
}

export function fromSkillCbor(bytes: Uint8Array): Skill {
  return fromSkillCborValue(decode(bytes));
}

export function toMemberSkillCborValue(v: MemberSkill): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("skill_id", v.skillId);
  csilMap.set("member_id", v.memberId);
  csilMap.set("created_at", v.createdAt);
  return csilMap;
}

export function fromMemberSkillCborValue(value: CborValue): MemberSkill {
  return {
    memberId: asString(requireKey(value, "member_id")),
    skillId: asString(requireKey(value, "skill_id")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toMemberSkillCbor(v: MemberSkill): Uint8Array {
  return encodeValue(toMemberSkillCborValue(v));
}

export function fromMemberSkillCbor(bytes: Uint8Array): MemberSkill {
  return fromMemberSkillCborValue(decode(bytes));
}

export function toGroupSkillCborValue(v: GroupSkill): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("group_id", v.groupId);
  csilMap.set("skill_id", v.skillId);
  csilMap.set("created_at", v.createdAt);
  return csilMap;
}

export function fromGroupSkillCborValue(value: CborValue): GroupSkill {
  return {
    groupId: asString(requireKey(value, "group_id")),
    skillId: asString(requireKey(value, "skill_id")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toGroupSkillCbor(v: GroupSkill): Uint8Array {
  return encodeValue(toGroupSkillCborValue(v));
}

export function fromGroupSkillCbor(bytes: Uint8Array): GroupSkill {
  return fromGroupSkillCborValue(decode(bytes));
}

export function toGroupCborValue(v: Group): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("name", v.name);
  csilMap.set("group_id", v.groupId);
  csilMap.set("house_id", v.houseId);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("updated_at", v.updatedAt);
  if (v.description !== undefined) csilMap.set("description", v.description);
  return csilMap;
}

export function fromGroupCborValue(value: CborValue): Group {
  return {
    groupId: asString(requireKey(value, "group_id")),
    houseId: asString(requireKey(value, "house_id")),
    name: asString(requireKey(value, "name")),
    description: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "description")),
    createdAt: asString(requireKey(value, "created_at")),
    updatedAt: asString(requireKey(value, "updated_at")),
  };
}

export function toGroupCbor(v: Group): Uint8Array {
  return encodeValue(toGroupCborValue(v));
}

export function fromGroupCbor(bytes: Uint8Array): Group {
  return fromGroupCborValue(decode(bytes));
}

export function toGroupMemberCborValue(v: GroupMember): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("group_id", v.groupId);
  csilMap.set("member_id", v.memberId);
  csilMap.set("created_at", v.createdAt);
  return csilMap;
}

export function fromGroupMemberCborValue(value: CborValue): GroupMember {
  return {
    groupId: asString(requireKey(value, "group_id")),
    memberId: asString(requireKey(value, "member_id")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toGroupMemberCbor(v: GroupMember): Uint8Array {
  return encodeValue(toGroupMemberCborValue(v));
}

export function fromGroupMemberCbor(bytes: Uint8Array): GroupMember {
  return fromGroupMemberCborValue(decode(bytes));
}

export function toProjectCborValue(v: Project): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("name", v.name);
  if (v.status !== undefined) csilMap.set("status", v.status);
  if (v.category !== undefined) csilMap.set("category", v.category);
  csilMap.set("house_id", v.houseId);
  if (v.personal !== undefined) csilMap.set("personal", v.personal);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("project_id", v.projectId);
  csilMap.set("updated_at", v.updatedAt);
  if (v.visibility !== undefined) csilMap.set("visibility", v.visibility);
  if (v.description !== undefined) csilMap.set("description", v.description);
  if (v.createdByMemberId !== undefined) csilMap.set("created_by_member_id", v.createdByMemberId);
  return csilMap;
}

export function fromProjectCborValue(value: CborValue): Project {
  return {
    projectId: asString(requireKey(value, "project_id")),
    houseId: asString(requireKey(value, "house_id")),
    name: asString(requireKey(value, "name")),
    description: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "description")),
    category: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "category")),
    status: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["active", "archived"]) as "active" | "archived"))(mapGet(value, "status")),
    visibility: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["none", "read", "edit", "full"]) as "none" | "read" | "edit" | "full"))(mapGet(value, "visibility")),
    createdByMemberId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "created_by_member_id")),
    personal: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asBool(csilV))(mapGet(value, "personal")),
    createdAt: asString(requireKey(value, "created_at")),
    updatedAt: asString(requireKey(value, "updated_at")),
  };
}

export function toProjectCbor(v: Project): Uint8Array {
  return encodeValue(toProjectCborValue(v));
}

export function fromProjectCbor(bytes: Uint8Array): Project {
  return fromProjectCborValue(decode(bytes));
}

export function toProjectTaskCborValue(v: ProjectTask): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("task_id", v.taskId);
  csilMap.set("position", v.position);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("project_id", v.projectId);
  return csilMap;
}

export function fromProjectTaskCborValue(value: CborValue): ProjectTask {
  return {
    projectId: asString(requireKey(value, "project_id")),
    taskId: asString(requireKey(value, "task_id")),
    position: asNumber(requireKey(value, "position")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toProjectTaskCbor(v: ProjectTask): Uint8Array {
  return encodeValue(toProjectTaskCborValue(v));
}

export function fromProjectTaskCbor(bytes: Uint8Array): ProjectTask {
  return fromProjectTaskCborValue(decode(bytes));
}

export function toProjectMemberCborValue(v: ProjectMember): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("member_id", v.memberId);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("project_id", v.projectId);
  return csilMap;
}

export function fromProjectMemberCborValue(value: CborValue): ProjectMember {
  return {
    projectId: asString(requireKey(value, "project_id")),
    memberId: asString(requireKey(value, "member_id")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toProjectMemberCbor(v: ProjectMember): Uint8Array {
  return encodeValue(toProjectMemberCborValue(v));
}

export function fromProjectMemberCbor(bytes: Uint8Array): ProjectMember {
  return fromProjectMemberCborValue(decode(bytes));
}

export function toProjectOwnerCborValue(v: ProjectOwner): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("member_id", v.memberId);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("project_id", v.projectId);
  return csilMap;
}

export function fromProjectOwnerCborValue(value: CborValue): ProjectOwner {
  return {
    projectId: asString(requireKey(value, "project_id")),
    memberId: asString(requireKey(value, "member_id")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toProjectOwnerCbor(v: ProjectOwner): Uint8Array {
  return encodeValue(toProjectOwnerCborValue(v));
}

export function fromProjectOwnerCbor(bytes: Uint8Array): ProjectOwner {
  return fromProjectOwnerCborValue(decode(bytes));
}

export function toMilestoneCborValue(v: Milestone): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("label", v.label);
  csilMap.set("state", v.state);
  csilMap.set("position", v.position);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("project_id", v.projectId);
  csilMap.set("updated_at", v.updatedAt);
  csilMap.set("when_label", v.whenLabel);
  csilMap.set("milestone_id", v.milestoneId);
  return csilMap;
}

export function fromMilestoneCborValue(value: CborValue): Milestone {
  return {
    milestoneId: asString(requireKey(value, "milestone_id")),
    projectId: asString(requireKey(value, "project_id")),
    label: asString(requireKey(value, "label")),
    whenLabel: asString(requireKey(value, "when_label")),
    state: (asEnumMember(asString(requireKey(value, "state")), ["done", "current", "future"]) as "done" | "current" | "future"),
    position: asNumber(requireKey(value, "position")),
    createdAt: asString(requireKey(value, "created_at")),
    updatedAt: asString(requireKey(value, "updated_at")),
  };
}

export function toMilestoneCbor(v: Milestone): Uint8Array {
  return encodeValue(toMilestoneCborValue(v));
}

export function fromMilestoneCbor(bytes: Uint8Array): Milestone {
  return fromMilestoneCborValue(decode(bytes));
}

export function toEventCborValue(v: Event): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("title", v.title);
  if (v.allDay !== undefined) csilMap.set("all_day", v.allDay);
  if (v.endsAt !== undefined) csilMap.set("ends_at", v.endsAt);
  csilMap.set("event_id", v.eventId);
  csilMap.set("house_id", v.houseId);
  if (v.location !== undefined) csilMap.set("location", v.location);
  if (v.startsAt !== undefined) csilMap.set("starts_at", v.startsAt);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("updated_at", v.updatedAt);
  if (v.description !== undefined) csilMap.set("description", v.description);
  csilMap.set("owner_member_id", v.ownerMemberId);
  if (v.recurrenceFreq !== undefined) csilMap.set("recurrence_freq", v.recurrenceFreq);
  if (v.nextRecurrenceAt !== undefined) csilMap.set("next_recurrence_at", v.nextRecurrenceAt);
  if (v.recurrenceInterval !== undefined) csilMap.set("recurrence_interval", v.recurrenceInterval);
  if (v.recurrenceBySetpos !== undefined) csilMap.set("recurrence_by_setpos", v.recurrenceBySetpos);
  if (v.recurrenceByWeekday !== undefined) csilMap.set("recurrence_by_weekday", v.recurrenceByWeekday);
  if (v.recurrenceRootEventId !== undefined) csilMap.set("recurrence_root_event_id", v.recurrenceRootEventId);
  return csilMap;
}

export function fromEventCborValue(value: CborValue): Event {
  return {
    eventId: asString(requireKey(value, "event_id")),
    houseId: asString(requireKey(value, "house_id")),
    ownerMemberId: asString(requireKey(value, "owner_member_id")),
    title: asString(requireKey(value, "title")),
    description: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "description")),
    location: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "location")),
    startsAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "starts_at")),
    endsAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "ends_at")),
    allDay: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asBool(csilV))(mapGet(value, "all_day")),
    recurrenceFreq: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["hourly", "daily", "weekly", "monthly", "quarterly", "yearly"]) as "hourly" | "daily" | "weekly" | "monthly" | "quarterly" | "yearly"))(mapGet(value, "recurrence_freq")),
    recurrenceInterval: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "recurrence_interval")),
    recurrenceByWeekday: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asArray(csilV).map((csilE) => asNumber(csilE)))(mapGet(value, "recurrence_by_weekday")),
    recurrenceBySetpos: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "recurrence_by_setpos")),
    nextRecurrenceAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "next_recurrence_at")),
    recurrenceRootEventId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "recurrence_root_event_id")),
    createdAt: asString(requireKey(value, "created_at")),
    updatedAt: asString(requireKey(value, "updated_at")),
  };
}

export function toEventCbor(v: Event): Uint8Array {
  return encodeValue(toEventCborValue(v));
}

export function fromEventCbor(bytes: Uint8Array): Event {
  return fromEventCborValue(decode(bytes));
}

export function toTaskCborValue(v: Task): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.tag !== undefined) csilMap.set("tag", v.tag);
  csilMap.set("title", v.title);
  if (v.dueAt !== undefined) csilMap.set("due_at", v.dueAt);
  if (v.status !== undefined) csilMap.set("status", v.status);
  csilMap.set("task_id", v.taskId);
  csilMap.set("house_id", v.houseId);
  if (v.assignees !== undefined) csilMap.set("assignees", v.assignees);
  csilMap.set("created_at", v.createdAt);
  if (v.deletedAt !== undefined) csilMap.set("deleted_at", v.deletedAt);
  csilMap.set("updated_at", v.updatedAt);
  if (v.visibility !== undefined) csilMap.set("visibility", v.visibility);
  if (v.description !== undefined) csilMap.set("description", v.description);
  if (v.parentTaskId !== undefined) csilMap.set("parent_task_id", v.parentTaskId);
  csilMap.set("owner_member_id", v.ownerMemberId);
  if (v.recurrenceFreq !== undefined) csilMap.set("recurrence_freq", v.recurrenceFreq);
  if (v.estimateMinutes !== undefined) csilMap.set("estimate_minutes", v.estimateMinutes);
  if (v.nextRecurrenceAt !== undefined) csilMap.set("next_recurrence_at", v.nextRecurrenceAt);
  if (v.recurrenceInterval !== undefined) csilMap.set("recurrence_interval", v.recurrenceInterval);
  if (v.assignedToSkillId !== undefined) csilMap.set("assigned_to_skill_id", v.assignedToSkillId);
  if (v.recurrenceBySetpos !== undefined) csilMap.set("recurrence_by_setpos", v.recurrenceBySetpos);
  if (v.recurrenceByWeekday !== undefined) csilMap.set("recurrence_by_weekday", v.recurrenceByWeekday);
  if (v.recurrenceRootTaskId !== undefined) csilMap.set("recurrence_root_task_id", v.recurrenceRootTaskId);
  return csilMap;
}

export function fromTaskCborValue(value: CborValue): Task {
  return {
    taskId: asString(requireKey(value, "task_id")),
    houseId: asString(requireKey(value, "house_id")),
    ownerMemberId: asString(requireKey(value, "owner_member_id")),
    assignees: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asArray(csilV).map((csilE) => asString(csilE)))(mapGet(value, "assignees")),
    assignedToSkillId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "assigned_to_skill_id")),
    parentTaskId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "parent_task_id")),
    visibility: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["none", "read", "edit", "full"]) as "none" | "read" | "edit" | "full"))(mapGet(value, "visibility")),
    title: asString(requireKey(value, "title")),
    description: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "description")),
    status: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["open", "in_progress", "done", "cancelled"]) as "open" | "in_progress" | "done" | "cancelled"))(mapGet(value, "status")),
    dueAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "due_at")),
    tag: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "tag")),
    estimateMinutes: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "estimate_minutes")),
    recurrenceFreq: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["hourly", "daily", "weekly", "monthly", "quarterly", "yearly"]) as "hourly" | "daily" | "weekly" | "monthly" | "quarterly" | "yearly"))(mapGet(value, "recurrence_freq")),
    recurrenceInterval: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "recurrence_interval")),
    recurrenceByWeekday: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asArray(csilV).map((csilE) => asNumber(csilE)))(mapGet(value, "recurrence_by_weekday")),
    recurrenceBySetpos: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "recurrence_by_setpos")),
    nextRecurrenceAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "next_recurrence_at")),
    recurrenceRootTaskId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "recurrence_root_task_id")),
    deletedAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "deleted_at")),
    createdAt: asString(requireKey(value, "created_at")),
    updatedAt: asString(requireKey(value, "updated_at")),
  };
}

export function toTaskCbor(v: Task): Uint8Array {
  return encodeValue(toTaskCborValue(v));
}

export function fromTaskCbor(bytes: Uint8Array): Task {
  return fromTaskCborValue(decode(bytes));
}

export function toCommentCborValue(v: Comment): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("body", v.body);
  csilMap.set("house_id", v.houseId);
  csilMap.set("member_id", v.memberId);
  csilMap.set("target_id", v.targetId);
  csilMap.set("comment_id", v.commentId);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("updated_at", v.updatedAt);
  csilMap.set("target_type", v.targetType);
  return csilMap;
}

export function fromCommentCborValue(value: CborValue): Comment {
  return {
    commentId: asString(requireKey(value, "comment_id")),
    houseId: asString(requireKey(value, "house_id")),
    memberId: asString(requireKey(value, "member_id")),
    targetType: (asEnumMember(asString(requireKey(value, "target_type")), ["event", "task", "project"]) as "event" | "task" | "project"),
    targetId: asString(requireKey(value, "target_id")),
    body: asString(requireKey(value, "body")),
    createdAt: asString(requireKey(value, "created_at")),
    updatedAt: asString(requireKey(value, "updated_at")),
  };
}

export function toCommentCbor(v: Comment): Uint8Array {
  return encodeValue(toCommentCborValue(v));
}

export function fromCommentCbor(bytes: Uint8Array): Comment {
  return fromCommentCborValue(decode(bytes));
}

export function toShareCborValue(v: Share): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("house_id", v.houseId);
  csilMap.set("share_id", v.shareId);
  csilMap.set("shared_by", v.sharedBy);
  csilMap.set("created_at", v.createdAt);
  if (v.expiresAt !== undefined) csilMap.set("expires_at", v.expiresAt);
  csilMap.set("resource_id", v.resourceId);
  if (v.accessLevel !== undefined) csilMap.set("access_level", v.accessLevel);
  csilMap.set("resource_type", v.resourceType);
  csilMap.set("linkkeys_domain", v.linkkeysDomain);
  csilMap.set("linkkeys_user_id", v.linkkeysUserId);
  return csilMap;
}

export function fromShareCborValue(value: CborValue): Share {
  return {
    shareId: asString(requireKey(value, "share_id")),
    houseId: asString(requireKey(value, "house_id")),
    sharedBy: asString(requireKey(value, "shared_by")),
    linkkeysDomain: asString(requireKey(value, "linkkeys_domain")),
    linkkeysUserId: asString(requireKey(value, "linkkeys_user_id")),
    resourceType: (asEnumMember(asString(requireKey(value, "resource_type")), ["event", "task", "house"]) as "event" | "task" | "house"),
    resourceId: asString(requireKey(value, "resource_id")),
    accessLevel: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["none", "read", "edit", "full"]) as "none" | "read" | "edit" | "full"))(mapGet(value, "access_level")),
    createdAt: asString(requireKey(value, "created_at")),
    expiresAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "expires_at")),
  };
}

export function toShareCbor(v: Share): Uint8Array {
  return encodeValue(toShareCborValue(v));
}

export function fromShareCbor(bytes: Uint8Array): Share {
  return fromShareCborValue(decode(bytes));
}

export function toHouseSummaryCborValue(v: HouseSummary): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("name", v.name);
  csilMap.set("roles", v.roles);
  csilMap.set("house_id", v.houseId);
  csilMap.set("member_id", v.memberId);
  return csilMap;
}

export function fromHouseSummaryCborValue(value: CborValue): HouseSummary {
  return {
    houseId: asString(requireKey(value, "house_id")),
    name: asString(requireKey(value, "name")),
    memberId: asString(requireKey(value, "member_id")),
    roles: asArray(requireKey(value, "roles")).map((csilE) => asString(csilE)),
  };
}

export function toHouseSummaryCbor(v: HouseSummary): Uint8Array {
  return encodeValue(toHouseSummaryCborValue(v));
}

export function fromHouseSummaryCbor(bytes: Uint8Array): HouseSummary {
  return fromHouseSummaryCborValue(decode(bytes));
}

export function toHouseRolesCborValue(v: HouseRoles): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("house", v.house);
  csilMap.set("roles", v.roles);
  csilMap.set("member", v.member);
  return csilMap;
}

export function fromHouseRolesCborValue(value: CborValue): HouseRoles {
  return {
    house: asString(requireKey(value, "house")),
    member: asString(requireKey(value, "member")),
    roles: asArray(requireKey(value, "roles")).map((csilE) => asString(csilE)),
  };
}

export function toHouseRolesCbor(v: HouseRoles): Uint8Array {
  return encodeValue(toHouseRolesCborValue(v));
}

export function fromHouseRolesCbor(bytes: Uint8Array): HouseRoles {
  return fromHouseRolesCborValue(decode(bytes));
}

export function toIdentityCborValue(v: Identity): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("exp", v.exp);
  csilMap.set("iat", v.iat);
  csilMap.set("domain", v.domain);
  csilMap.set("houses", v.houses.map((csilE): CborValue => toHouseRolesCborValue(csilE)));
  csilMap.set("user_id", v.userId);
  if (v.displayName !== undefined) csilMap.set("display_name", v.displayName);
  return csilMap;
}

export function fromIdentityCborValue(value: CborValue): Identity {
  return {
    domain: asString(requireKey(value, "domain")),
    userId: asString(requireKey(value, "user_id")),
    displayName: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "display_name")),
    houses: asArray(requireKey(value, "houses")).map((csilE) => fromHouseRolesCborValue(csilE)),
    iat: asNumber(requireKey(value, "iat")),
    exp: asNumber(requireKey(value, "exp")),
  };
}

export function toIdentityCbor(v: Identity): Uint8Array {
  return encodeValue(toIdentityCborValue(v));
}

export function fromIdentityCbor(bytes: Uint8Array): Identity {
  return fromIdentityCborValue(decode(bytes));
}

export function toLoginRequestCborValue(v: LoginRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("signed_assertion", v.signedAssertion);
  return csilMap;
}

export function fromLoginRequestCborValue(value: CborValue): LoginRequest {
  return {
    signedAssertion: asString(requireKey(value, "signed_assertion")),
  };
}

export function toLoginRequestCbor(v: LoginRequest): Uint8Array {
  return encodeValue(toLoginRequestCborValue(v));
}

export function fromLoginRequestCbor(bytes: Uint8Array): LoginRequest {
  return fromLoginRequestCborValue(decode(bytes));
}

export function toCompleteRequestCborValue(v: CompleteRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("encrypted_token", v.encryptedToken);
  return csilMap;
}

export function fromCompleteRequestCborValue(value: CborValue): CompleteRequest {
  return {
    encryptedToken: asString(requireKey(value, "encrypted_token")),
  };
}

export function toCompleteRequestCbor(v: CompleteRequest): Uint8Array {
  return encodeValue(toCompleteRequestCborValue(v));
}

export function fromCompleteRequestCbor(bytes: Uint8Array): CompleteRequest {
  return fromCompleteRequestCborValue(decode(bytes));
}

export function toLoginResponseCborValue(v: LoginResponse): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("token", v.token);
  csilMap.set("domain", v.domain);
  csilMap.set("user_id", v.userId);
  csilMap.set("expires_at", v.expiresAt);
  if (v.displayName !== undefined) csilMap.set("display_name", v.displayName);
  return csilMap;
}

export function fromLoginResponseCborValue(value: CborValue): LoginResponse {
  return {
    token: asString(requireKey(value, "token")),
    domain: asString(requireKey(value, "domain")),
    userId: asString(requireKey(value, "user_id")),
    displayName: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "display_name")),
    expiresAt: asString(requireKey(value, "expires_at")),
  };
}

export function toLoginResponseCbor(v: LoginResponse): Uint8Array {
  return encodeValue(toLoginResponseCborValue(v));
}

export function fromLoginResponseCbor(bytes: Uint8Array): LoginResponse {
  return fromLoginResponseCborValue(decode(bytes));
}

export function toCliTokenResponseCborValue(v: CliTokenResponse): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("token", v.token);
  csilMap.set("domain", v.domain);
  csilMap.set("user_id", v.userId);
  csilMap.set("expires_at", v.expiresAt);
  csilMap.set("session_id", v.sessionId);
  if (v.displayName !== undefined) csilMap.set("display_name", v.displayName);
  csilMap.set("refresh_token", v.refreshToken);
  csilMap.set("refresh_expires_at", v.refreshExpiresAt);
  return csilMap;
}

export function fromCliTokenResponseCborValue(value: CborValue): CliTokenResponse {
  return {
    token: asString(requireKey(value, "token")),
    domain: asString(requireKey(value, "domain")),
    userId: asString(requireKey(value, "user_id")),
    displayName: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "display_name")),
    expiresAt: asString(requireKey(value, "expires_at")),
    refreshToken: asString(requireKey(value, "refresh_token")),
    refreshExpiresAt: asString(requireKey(value, "refresh_expires_at")),
    sessionId: asString(requireKey(value, "session_id")),
  };
}

export function toCliTokenResponseCbor(v: CliTokenResponse): Uint8Array {
  return encodeValue(toCliTokenResponseCborValue(v));
}

export function fromCliTokenResponseCbor(bytes: Uint8Array): CliTokenResponse {
  return fromCliTokenResponseCborValue(decode(bytes));
}

export function toBeginCliLoginRequestCborValue(v: BeginCliLoginRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("client_name", v.clientName);
  return csilMap;
}

export function fromBeginCliLoginRequestCborValue(value: CborValue): BeginCliLoginRequest {
  return {
    clientName: asString(requireKey(value, "client_name")),
  };
}

export function toBeginCliLoginRequestCbor(v: BeginCliLoginRequest): Uint8Array {
  return encodeValue(toBeginCliLoginRequestCborValue(v));
}

export function fromBeginCliLoginRequestCbor(bytes: Uint8Array): BeginCliLoginRequest {
  return fromBeginCliLoginRequestCborValue(decode(bytes));
}

export function toBeginCliLoginResponseCborValue(v: BeginCliLoginResponse): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("user_code", v.userCode);
  csilMap.set("expires_at", v.expiresAt);
  csilMap.set("device_code", v.deviceCode);
  csilMap.set("interval_seconds", v.intervalSeconds);
  csilMap.set("verification_url", v.verificationUrl);
  return csilMap;
}

export function fromBeginCliLoginResponseCborValue(value: CborValue): BeginCliLoginResponse {
  return {
    deviceCode: asString(requireKey(value, "device_code")),
    userCode: asString(requireKey(value, "user_code")),
    verificationUrl: asString(requireKey(value, "verification_url")),
    expiresAt: asString(requireKey(value, "expires_at")),
    intervalSeconds: asNumber(requireKey(value, "interval_seconds")),
  };
}

export function toBeginCliLoginResponseCbor(v: BeginCliLoginResponse): Uint8Array {
  return encodeValue(toBeginCliLoginResponseCborValue(v));
}

export function fromBeginCliLoginResponseCbor(bytes: Uint8Array): BeginCliLoginResponse {
  return fromBeginCliLoginResponseCborValue(decode(bytes));
}

export function toApproveCliLoginRequestCborValue(v: ApproveCliLoginRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("user_code", v.userCode);
  return csilMap;
}

export function fromApproveCliLoginRequestCborValue(value: CborValue): ApproveCliLoginRequest {
  return {
    userCode: asString(requireKey(value, "user_code")),
  };
}

export function toApproveCliLoginRequestCbor(v: ApproveCliLoginRequest): Uint8Array {
  return encodeValue(toApproveCliLoginRequestCborValue(v));
}

export function fromApproveCliLoginRequestCbor(bytes: Uint8Array): ApproveCliLoginRequest {
  return fromApproveCliLoginRequestCborValue(decode(bytes));
}

export function toCliLoginRequestInfoCborValue(v: CliLoginRequestInfo): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("user_code", v.userCode);
  csilMap.set("expires_at", v.expiresAt);
  csilMap.set("client_name", v.clientName);
  return csilMap;
}

export function fromCliLoginRequestInfoCborValue(value: CborValue): CliLoginRequestInfo {
  return {
    userCode: asString(requireKey(value, "user_code")),
    clientName: asString(requireKey(value, "client_name")),
    expiresAt: asString(requireKey(value, "expires_at")),
  };
}

export function toCliLoginRequestInfoCbor(v: CliLoginRequestInfo): Uint8Array {
  return encodeValue(toCliLoginRequestInfoCborValue(v));
}

export function fromCliLoginRequestInfoCbor(bytes: Uint8Array): CliLoginRequestInfo {
  return fromCliLoginRequestInfoCborValue(decode(bytes));
}

export function toDenyCliLoginRequestCborValue(v: DenyCliLoginRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("user_code", v.userCode);
  return csilMap;
}

export function fromDenyCliLoginRequestCborValue(value: CborValue): DenyCliLoginRequest {
  return {
    userCode: asString(requireKey(value, "user_code")),
  };
}

export function toDenyCliLoginRequestCbor(v: DenyCliLoginRequest): Uint8Array {
  return encodeValue(toDenyCliLoginRequestCborValue(v));
}

export function fromDenyCliLoginRequestCbor(bytes: Uint8Array): DenyCliLoginRequest {
  return fromDenyCliLoginRequestCborValue(decode(bytes));
}

export function toExchangeCliLoginRequestCborValue(v: ExchangeCliLoginRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("device_code", v.deviceCode);
  return csilMap;
}

export function fromExchangeCliLoginRequestCborValue(value: CborValue): ExchangeCliLoginRequest {
  return {
    deviceCode: asString(requireKey(value, "device_code")),
  };
}

export function toExchangeCliLoginRequestCbor(v: ExchangeCliLoginRequest): Uint8Array {
  return encodeValue(toExchangeCliLoginRequestCborValue(v));
}

export function fromExchangeCliLoginRequestCbor(bytes: Uint8Array): ExchangeCliLoginRequest {
  return fromExchangeCliLoginRequestCborValue(decode(bytes));
}

export function toExchangeCliLoginResponseCborValue(v: ExchangeCliLoginResponse): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("status", v.status);
  if (v.session !== undefined) csilMap.set("session", toCliTokenResponseCborValue(v.session));
  return csilMap;
}

export function fromExchangeCliLoginResponseCborValue(value: CborValue): ExchangeCliLoginResponse {
  return {
    status: (asEnumMember(asString(requireKey(value, "status")), ["pending", "denied", "expired", "complete"]) as "pending" | "denied" | "expired" | "complete"),
    session: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : fromCliTokenResponseCborValue(csilV))(mapGet(value, "session")),
  };
}

export function toExchangeCliLoginResponseCbor(v: ExchangeCliLoginResponse): Uint8Array {
  return encodeValue(toExchangeCliLoginResponseCborValue(v));
}

export function fromExchangeCliLoginResponseCbor(bytes: Uint8Array): ExchangeCliLoginResponse {
  return fromExchangeCliLoginResponseCborValue(decode(bytes));
}

export function toRefreshSessionRequestCborValue(v: RefreshSessionRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("refresh_token", v.refreshToken);
  return csilMap;
}

export function fromRefreshSessionRequestCborValue(value: CborValue): RefreshSessionRequest {
  return {
    refreshToken: asString(requireKey(value, "refresh_token")),
  };
}

export function toRefreshSessionRequestCbor(v: RefreshSessionRequest): Uint8Array {
  return encodeValue(toRefreshSessionRequestCborValue(v));
}

export function fromRefreshSessionRequestCbor(bytes: Uint8Array): RefreshSessionRequest {
  return fromRefreshSessionRequestCborValue(decode(bytes));
}

export function toCliSessionSummaryCborValue(v: CliSessionSummary): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.kind !== undefined) csilMap.set("kind", v.kind);
  if (v.current !== undefined) csilMap.set("current", v.current);
  csilMap.set("created_at", v.createdAt);
  csilMap.set("expires_at", v.expiresAt);
  if (v.revokedAt !== undefined) csilMap.set("revoked_at", v.revokedAt);
  csilMap.set("session_id", v.sessionId);
  csilMap.set("client_name", v.clientName);
  csilMap.set("last_used_at", v.lastUsedAt);
  return csilMap;
}

export function fromCliSessionSummaryCborValue(value: CborValue): CliSessionSummary {
  return {
    sessionId: asString(requireKey(value, "session_id")),
    clientName: asString(requireKey(value, "client_name")),
    createdAt: asString(requireKey(value, "created_at")),
    lastUsedAt: asString(requireKey(value, "last_used_at")),
    expiresAt: asString(requireKey(value, "expires_at")),
    revokedAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "revoked_at")),
    kind: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["cli", "browser"]) as "cli" | "browser"))(mapGet(value, "kind")),
    current: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asBool(csilV))(mapGet(value, "current")),
  };
}

export function toCliSessionSummaryCbor(v: CliSessionSummary): Uint8Array {
  return encodeValue(toCliSessionSummaryCborValue(v));
}

export function fromCliSessionSummaryCbor(bytes: Uint8Array): CliSessionSummary {
  return fromCliSessionSummaryCborValue(decode(bytes));
}

export function toCliSessionsResponseCborValue(v: CliSessionsResponse): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("sessions", v.sessions.map((csilE): CborValue => toCliSessionSummaryCborValue(csilE)));
  return csilMap;
}

export function fromCliSessionsResponseCborValue(value: CborValue): CliSessionsResponse {
  return {
    sessions: asArray(requireKey(value, "sessions")).map((csilE) => fromCliSessionSummaryCborValue(csilE)),
  };
}

export function toCliSessionsResponseCbor(v: CliSessionsResponse): Uint8Array {
  return encodeValue(toCliSessionsResponseCborValue(v));
}

export function fromCliSessionsResponseCbor(bytes: Uint8Array): CliSessionsResponse {
  return fromCliSessionsResponseCborValue(decode(bytes));
}

export function toRevokeSessionRequestCborValue(v: RevokeSessionRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("session_id", v.sessionId);
  return csilMap;
}

export function fromRevokeSessionRequestCborValue(value: CborValue): RevokeSessionRequest {
  return {
    sessionId: asString(requireKey(value, "session_id")),
  };
}

export function toRevokeSessionRequestCbor(v: RevokeSessionRequest): Uint8Array {
  return encodeValue(toRevokeSessionRequestCborValue(v));
}

export function fromRevokeSessionRequestCbor(bytes: Uint8Array): RevokeSessionRequest {
  return fromRevokeSessionRequestCborValue(decode(bytes));
}

export function toDevUserEntryCborValue(v: DevUserEntry): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("roles", v.roles);
  csilMap.set("house_id", v.houseId);
  csilMap.set("member_id", v.memberId);
  csilMap.set("house_name", v.houseName);
  if (v.displayName !== undefined) csilMap.set("display_name", v.displayName);
  if (v.linkkeysDomain !== undefined) csilMap.set("linkkeys_domain", v.linkkeysDomain);
  if (v.linkkeysUserId !== undefined) csilMap.set("linkkeys_user_id", v.linkkeysUserId);
  return csilMap;
}

export function fromDevUserEntryCborValue(value: CborValue): DevUserEntry {
  return {
    memberId: asString(requireKey(value, "member_id")),
    houseId: asString(requireKey(value, "house_id")),
    houseName: asString(requireKey(value, "house_name")),
    displayName: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "display_name")),
    linkkeysDomain: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "linkkeys_domain")),
    linkkeysUserId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "linkkeys_user_id")),
    roles: asArray(requireKey(value, "roles")).map((csilE) => asString(csilE)),
  };
}

export function toDevUserEntryCbor(v: DevUserEntry): Uint8Array {
  return encodeValue(toDevUserEntryCborValue(v));
}

export function fromDevUserEntryCbor(bytes: Uint8Array): DevUserEntry {
  return fromDevUserEntryCborValue(decode(bytes));
}

export function toDevUsersResponseCborValue(v: DevUsersResponse): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("users", v.users.map((csilE): CborValue => toDevUserEntryCborValue(csilE)));
  return csilMap;
}

export function fromDevUsersResponseCborValue(value: CborValue): DevUsersResponse {
  return {
    users: asArray(requireKey(value, "users")).map((csilE) => fromDevUserEntryCborValue(csilE)),
  };
}

export function toDevUsersResponseCbor(v: DevUsersResponse): Uint8Array {
  return encodeValue(toDevUsersResponseCborValue(v));
}

export function fromDevUsersResponseCbor(bytes: Uint8Array): DevUsersResponse {
  return fromDevUsersResponseCborValue(decode(bytes));
}

export function toDevLoginRequestCborValue(v: DevLoginRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("member_id", v.memberId);
  return csilMap;
}

export function fromDevLoginRequestCborValue(value: CborValue): DevLoginRequest {
  return {
    memberId: asString(requireKey(value, "member_id")),
  };
}

export function toDevLoginRequestCbor(v: DevLoginRequest): Uint8Array {
  return encodeValue(toDevLoginRequestCborValue(v));
}

export function fromDevLoginRequestCbor(bytes: Uint8Array): DevLoginRequest {
  return fromDevLoginRequestCborValue(decode(bytes));
}

export function toMeResponseCborValue(v: MeResponse): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("domain", v.domain);
  csilMap.set("houses", v.houses.map((csilE): CborValue => toHouseSummaryCborValue(csilE)));
  csilMap.set("user_id", v.userId);
  csilMap.set("expires_at", v.expiresAt);
  if (v.displayName !== undefined) csilMap.set("display_name", v.displayName);
  return csilMap;
}

export function fromMeResponseCborValue(value: CborValue): MeResponse {
  return {
    domain: asString(requireKey(value, "domain")),
    userId: asString(requireKey(value, "user_id")),
    displayName: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "display_name")),
    expiresAt: asString(requireKey(value, "expires_at")),
    houses: asArray(requireKey(value, "houses")).map((csilE) => fromHouseSummaryCborValue(csilE)),
  };
}

export function toMeResponseCbor(v: MeResponse): Uint8Array {
  return encodeValue(toMeResponseCborValue(v));
}

export function fromMeResponseCbor(bytes: Uint8Array): MeResponse {
  return fromMeResponseCborValue(decode(bytes));
}

export function toEmptyRequestCborValue(v: EmptyRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  return csilMap;
}

export function fromEmptyRequestCborValue(value: CborValue): EmptyRequest {
  void value;
  return {} as EmptyRequest;
}

export function toEmptyRequestCbor(v: EmptyRequest): Uint8Array {
  return encodeValue(toEmptyRequestCborValue(v));
}

export function fromEmptyRequestCbor(bytes: Uint8Array): EmptyRequest {
  return fromEmptyRequestCborValue(decode(bytes));
}

export function toEmptyResponseCborValue(v: EmptyResponse): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  return csilMap;
}

export function fromEmptyResponseCborValue(value: CborValue): EmptyResponse {
  void value;
  return {} as EmptyResponse;
}

export function toEmptyResponseCbor(v: EmptyResponse): Uint8Array {
  return encodeValue(toEmptyResponseCborValue(v));
}

export function fromEmptyResponseCbor(bytes: Uint8Array): EmptyResponse {
  return fromEmptyResponseCborValue(decode(bytes));
}

export function toBoolResponseCborValue(v: BoolResponse): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("value", v.value);
  return csilMap;
}

export function fromBoolResponseCborValue(value: CborValue): BoolResponse {
  return {
    value: asBool(requireKey(value, "value")),
  };
}

export function toBoolResponseCbor(v: BoolResponse): Uint8Array {
  return encodeValue(toBoolResponseCborValue(v));
}

export function fromBoolResponseCbor(bytes: Uint8Array): BoolResponse {
  return fromBoolResponseCborValue(decode(bytes));
}

export function toHouseListRequestCborValue(v: HouseListRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.limit !== undefined) csilMap.set("limit", v.limit);
  if (v.offset !== undefined) csilMap.set("offset", v.offset);
  return csilMap;
}

export function fromHouseListRequestCborValue(value: CborValue): HouseListRequest {
  return {
    limit: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "limit")),
    offset: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "offset")),
  };
}

export function toHouseListRequestCbor(v: HouseListRequest): Uint8Array {
  return encodeValue(toHouseListRequestCborValue(v));
}

export function fromHouseListRequestCbor(bytes: Uint8Array): HouseListRequest {
  return fromHouseListRequestCborValue(decode(bytes));
}

export function toHouseScopedListRequestCborValue(v: HouseScopedListRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.limit !== undefined) csilMap.set("limit", v.limit);
  if (v.offset !== undefined) csilMap.set("offset", v.offset);
  csilMap.set("house_id", v.houseId);
  return csilMap;
}

export function fromHouseScopedListRequestCborValue(value: CborValue): HouseScopedListRequest {
  return {
    houseId: asString(requireKey(value, "house_id")),
    limit: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "limit")),
    offset: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "offset")),
  };
}

export function toHouseScopedListRequestCbor(v: HouseScopedListRequest): Uint8Array {
  return encodeValue(toHouseScopedListRequestCborValue(v));
}

export function fromHouseScopedListRequestCbor(bytes: Uint8Array): HouseScopedListRequest {
  return fromHouseScopedListRequestCborValue(decode(bytes));
}

export function toEventListRequestCborValue(v: EventListRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.limit !== undefined) csilMap.set("limit", v.limit);
  if (v.offset !== undefined) csilMap.set("offset", v.offset);
  csilMap.set("house_id", v.houseId);
  if (v.rangeEnd !== undefined) csilMap.set("range_end", v.rangeEnd);
  if (v.rangeStart !== undefined) csilMap.set("range_start", v.rangeStart);
  return csilMap;
}

export function fromEventListRequestCborValue(value: CborValue): EventListRequest {
  return {
    houseId: asString(requireKey(value, "house_id")),
    rangeStart: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "range_start")),
    rangeEnd: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "range_end")),
    limit: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "limit")),
    offset: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "offset")),
  };
}

export function toEventListRequestCbor(v: EventListRequest): Uint8Array {
  return encodeValue(toEventListRequestCborValue(v));
}

export function fromEventListRequestCbor(bytes: Uint8Array): EventListRequest {
  return fromEventListRequestCborValue(decode(bytes));
}

export function toTaskListRequestCborValue(v: TaskListRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.mine !== undefined) csilMap.set("mine", v.mine);
  if (v.limit !== undefined) csilMap.set("limit", v.limit);
  if (v.loose !== undefined) csilMap.set("loose", v.loose);
  if (v.state !== undefined) csilMap.set("state", v.state);
  if (v.dueTo !== undefined) csilMap.set("due_to", v.dueTo);
  if (v.offset !== undefined) csilMap.set("offset", v.offset);
  if (v.dueFrom !== undefined) csilMap.set("due_from", v.dueFrom);
  csilMap.set("house_id", v.houseId);
  if (v.dueBefore !== undefined) csilMap.set("due_before", v.dueBefore);
  return csilMap;
}

export function fromTaskListRequestCborValue(value: CborValue): TaskListRequest {
  return {
    houseId: asString(requireKey(value, "house_id")),
    limit: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "limit")),
    offset: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "offset")),
    state: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["open", "closed"]) as "open" | "closed"))(mapGet(value, "state")),
    mine: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asBool(csilV))(mapGet(value, "mine")),
    loose: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asBool(csilV))(mapGet(value, "loose")),
    dueFrom: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "due_from")),
    dueTo: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "due_to")),
    dueBefore: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asArray(csilV).map((csilE) => asString(csilE)))(mapGet(value, "due_before")),
  };
}

export function toTaskListRequestCbor(v: TaskListRequest): Uint8Array {
  return encodeValue(toTaskListRequestCborValue(v));
}

export function fromTaskListRequestCbor(bytes: Uint8Array): TaskListRequest {
  return fromTaskListRequestCborValue(decode(bytes));
}

export function toTaskListCborValue(v: TaskList): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("tasks", v.tasks.map((csilE): CborValue => toTaskCborValue(csilE)));
  if (v.total !== undefined) csilMap.set("total", v.total);
  if (v.dueCounts !== undefined) csilMap.set("due_counts", v.dueCounts);
  csilMap.set("hidden_count", v.hiddenCount);
  return csilMap;
}

export function fromTaskListCborValue(value: CborValue): TaskList {
  return {
    tasks: asArray(requireKey(value, "tasks")).map((csilE) => fromTaskCborValue(csilE)),
    hiddenCount: asNumber(requireKey(value, "hidden_count")),
    total: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "total")),
    dueCounts: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asArray(csilV).map((csilE) => asNumber(csilE)))(mapGet(value, "due_counts")),
  };
}

export function toTaskListCbor(v: TaskList): Uint8Array {
  return encodeValue(toTaskListCborValue(v));
}

export function fromTaskListCbor(bytes: Uint8Array): TaskList {
  return fromTaskListCborValue(decode(bytes));
}

export function toProjectListCborValue(v: ProjectList): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("projects", v.projects.map((csilE): CborValue => toProjectCborValue(csilE)));
  csilMap.set("hidden_count", v.hiddenCount);
  return csilMap;
}

export function fromProjectListCborValue(value: CborValue): ProjectList {
  return {
    projects: asArray(requireKey(value, "projects")).map((csilE) => fromProjectCborValue(csilE)),
    hiddenCount: asNumber(requireKey(value, "hidden_count")),
  };
}

export function toProjectListCbor(v: ProjectList): Uint8Array {
  return encodeValue(toProjectListCborValue(v));
}

export function fromProjectListCbor(bytes: Uint8Array): ProjectList {
  return fromProjectListCborValue(decode(bytes));
}

export function toMemberScopedListRequestCborValue(v: MemberScopedListRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.limit !== undefined) csilMap.set("limit", v.limit);
  if (v.offset !== undefined) csilMap.set("offset", v.offset);
  csilMap.set("house_id", v.houseId);
  csilMap.set("member_id", v.memberId);
  return csilMap;
}

export function fromMemberScopedListRequestCborValue(value: CborValue): MemberScopedListRequest {
  return {
    houseId: asString(requireKey(value, "house_id")),
    memberId: asString(requireKey(value, "member_id")),
    limit: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "limit")),
    offset: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "offset")),
  };
}

export function toMemberScopedListRequestCbor(v: MemberScopedListRequest): Uint8Array {
  return encodeValue(toMemberScopedListRequestCborValue(v));
}

export function fromMemberScopedListRequestCbor(bytes: Uint8Array): MemberScopedListRequest {
  return fromMemberScopedListRequestCborValue(decode(bytes));
}

export function toProjectScopedListRequestCborValue(v: ProjectScopedListRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.limit !== undefined) csilMap.set("limit", v.limit);
  if (v.state !== undefined) csilMap.set("state", v.state);
  if (v.offset !== undefined) csilMap.set("offset", v.offset);
  csilMap.set("house_id", v.houseId);
  csilMap.set("project_id", v.projectId);
  return csilMap;
}

export function fromProjectScopedListRequestCborValue(value: CborValue): ProjectScopedListRequest {
  return {
    houseId: asString(requireKey(value, "house_id")),
    projectId: asString(requireKey(value, "project_id")),
    limit: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "limit")),
    offset: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "offset")),
    state: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["open", "closed"]) as "open" | "closed"))(mapGet(value, "state")),
  };
}

export function toProjectScopedListRequestCbor(v: ProjectScopedListRequest): Uint8Array {
  return encodeValue(toProjectScopedListRequestCborValue(v));
}

export function fromProjectScopedListRequestCbor(bytes: Uint8Array): ProjectScopedListRequest {
  return fromProjectScopedListRequestCborValue(decode(bytes));
}

export function toCommentListRequestCborValue(v: CommentListRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.limit !== undefined) csilMap.set("limit", v.limit);
  if (v.offset !== undefined) csilMap.set("offset", v.offset);
  csilMap.set("target_id", v.targetId);
  csilMap.set("target_type", v.targetType);
  return csilMap;
}

export function fromCommentListRequestCborValue(value: CborValue): CommentListRequest {
  return {
    targetType: (asEnumMember(asString(requireKey(value, "target_type")), ["event", "task", "project"]) as "event" | "task" | "project"),
    targetId: asString(requireKey(value, "target_id")),
    limit: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "limit")),
    offset: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "offset")),
  };
}

export function toCommentListRequestCbor(v: CommentListRequest): Uint8Array {
  return encodeValue(toCommentListRequestCborValue(v));
}

export function fromCommentListRequestCbor(bytes: Uint8Array): CommentListRequest {
  return fromCommentListRequestCborValue(decode(bytes));
}

export function toNotificationCborValue(v: Notification): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("body", v.body);
  csilMap.set("kind", v.kind);
  csilMap.set("read", v.read);
  if (v.readAt !== undefined) csilMap.set("read_at", v.readAt);
  csilMap.set("house_id", v.houseId);
  csilMap.set("member_id", v.memberId);
  if (v.targetId !== undefined) csilMap.set("target_id", v.targetId);
  csilMap.set("actor_name", v.actorName);
  csilMap.set("created_at", v.createdAt);
  if (v.targetType !== undefined) csilMap.set("target_type", v.targetType);
  csilMap.set("target_title", v.targetTitle);
  if (v.actorMemberId !== undefined) csilMap.set("actor_member_id", v.actorMemberId);
  csilMap.set("notification_id", v.notificationId);
  return csilMap;
}

export function fromNotificationCborValue(value: CborValue): Notification {
  return {
    notificationId: asString(requireKey(value, "notification_id")),
    houseId: asString(requireKey(value, "house_id")),
    memberId: asString(requireKey(value, "member_id")),
    kind: asString(requireKey(value, "kind")),
    actorMemberId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "actor_member_id")),
    actorName: asString(requireKey(value, "actor_name")),
    targetType: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "target_type")),
    targetId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "target_id")),
    targetTitle: asString(requireKey(value, "target_title")),
    body: asString(requireKey(value, "body")),
    read: asBool(requireKey(value, "read")),
    readAt: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "read_at")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toNotificationCbor(v: Notification): Uint8Array {
  return encodeValue(toNotificationCborValue(v));
}

export function fromNotificationCbor(bytes: Uint8Array): Notification {
  return fromNotificationCborValue(decode(bytes));
}

export function toNotificationListRequestCborValue(v: NotificationListRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.limit !== undefined) csilMap.set("limit", v.limit);
  if (v.offset !== undefined) csilMap.set("offset", v.offset);
  csilMap.set("house_id", v.houseId);
  if (v.unreadOnly !== undefined) csilMap.set("unread_only", v.unreadOnly);
  return csilMap;
}

export function fromNotificationListRequestCborValue(value: CborValue): NotificationListRequest {
  return {
    houseId: asString(requireKey(value, "house_id")),
    unreadOnly: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asBool(csilV))(mapGet(value, "unread_only")),
    limit: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "limit")),
    offset: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "offset")),
  };
}

export function toNotificationListRequestCbor(v: NotificationListRequest): Uint8Array {
  return encodeValue(toNotificationListRequestCborValue(v));
}

export function fromNotificationListRequestCbor(bytes: Uint8Array): NotificationListRequest {
  return fromNotificationListRequestCborValue(decode(bytes));
}

export function toNotificationUnreadCountCborValue(v: NotificationUnreadCount): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("count", v.count);
  return csilMap;
}

export function fromNotificationUnreadCountCborValue(value: CborValue): NotificationUnreadCount {
  return {
    count: asNumber(requireKey(value, "count")),
  };
}

export function toNotificationUnreadCountCbor(v: NotificationUnreadCount): Uint8Array {
  return encodeValue(toNotificationUnreadCountCborValue(v));
}

export function fromNotificationUnreadCountCbor(bytes: Uint8Array): NotificationUnreadCount {
  return fromNotificationUnreadCountCborValue(decode(bytes));
}

export function toShareAccessRequestCborValue(v: ShareAccessRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("resource_id", v.resourceId);
  csilMap.set("resource_type", v.resourceType);
  csilMap.set("linkkeys_domain", v.linkkeysDomain);
  csilMap.set("linkkeys_user_id", v.linkkeysUserId);
  return csilMap;
}

export function fromShareAccessRequestCborValue(value: CborValue): ShareAccessRequest {
  return {
    linkkeysDomain: asString(requireKey(value, "linkkeys_domain")),
    linkkeysUserId: asString(requireKey(value, "linkkeys_user_id")),
    resourceType: (asEnumMember(asString(requireKey(value, "resource_type")), ["event", "task", "house"]) as "event" | "task" | "house"),
    resourceId: asString(requireKey(value, "resource_id")),
  };
}

export function toShareAccessRequestCbor(v: ShareAccessRequest): Uint8Array {
  return encodeValue(toShareAccessRequestCborValue(v));
}

export function fromShareAccessRequestCbor(bytes: Uint8Array): ShareAccessRequest {
  return fromShareAccessRequestCborValue(decode(bytes));
}

export function toResourceRefCborValue(v: ResourceRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("resource_id", v.resourceId);
  csilMap.set("resource_type", v.resourceType);
  return csilMap;
}

export function fromResourceRefCborValue(value: CborValue): ResourceRef {
  return {
    resourceType: (asEnumMember(asString(requireKey(value, "resource_type")), ["event", "task", "house"]) as "event" | "task" | "house"),
    resourceId: asString(requireKey(value, "resource_id")),
  };
}

export function toResourceRefCbor(v: ResourceRef): Uint8Array {
  return encodeValue(toResourceRefCborValue(v));
}

export function fromResourceRefCbor(bytes: Uint8Array): ResourceRef {
  return fromResourceRefCborValue(decode(bytes));
}

export function toMemberRoleRefCborValue(v: MemberRoleRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("role_id", v.roleId);
  csilMap.set("member_id", v.memberId);
  return csilMap;
}

export function fromMemberRoleRefCborValue(value: CborValue): MemberRoleRef {
  return {
    memberId: asString(requireKey(value, "member_id")),
    roleId: asString(requireKey(value, "role_id")),
  };
}

export function toMemberRoleRefCbor(v: MemberRoleRef): Uint8Array {
  return encodeValue(toMemberRoleRefCborValue(v));
}

export function fromMemberRoleRefCbor(bytes: Uint8Array): MemberRoleRef {
  return fromMemberRoleRefCborValue(decode(bytes));
}

export function toMemberSkillRefCborValue(v: MemberSkillRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("skill_id", v.skillId);
  csilMap.set("member_id", v.memberId);
  return csilMap;
}

export function fromMemberSkillRefCborValue(value: CborValue): MemberSkillRef {
  return {
    memberId: asString(requireKey(value, "member_id")),
    skillId: asString(requireKey(value, "skill_id")),
  };
}

export function toMemberSkillRefCbor(v: MemberSkillRef): Uint8Array {
  return encodeValue(toMemberSkillRefCborValue(v));
}

export function fromMemberSkillRefCbor(bytes: Uint8Array): MemberSkillRef {
  return fromMemberSkillRefCborValue(decode(bytes));
}

export function toGroupSkillRefCborValue(v: GroupSkillRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("group_id", v.groupId);
  csilMap.set("skill_id", v.skillId);
  return csilMap;
}

export function fromGroupSkillRefCborValue(value: CborValue): GroupSkillRef {
  return {
    groupId: asString(requireKey(value, "group_id")),
    skillId: asString(requireKey(value, "skill_id")),
  };
}

export function toGroupSkillRefCbor(v: GroupSkillRef): Uint8Array {
  return encodeValue(toGroupSkillRefCborValue(v));
}

export function fromGroupSkillRefCbor(bytes: Uint8Array): GroupSkillRef {
  return fromGroupSkillRefCborValue(decode(bytes));
}

export function toGroupMemberRefCborValue(v: GroupMemberRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("group_id", v.groupId);
  csilMap.set("member_id", v.memberId);
  return csilMap;
}

export function fromGroupMemberRefCborValue(value: CborValue): GroupMemberRef {
  return {
    groupId: asString(requireKey(value, "group_id")),
    memberId: asString(requireKey(value, "member_id")),
  };
}

export function toGroupMemberRefCbor(v: GroupMemberRef): Uint8Array {
  return encodeValue(toGroupMemberRefCborValue(v));
}

export function fromGroupMemberRefCbor(bytes: Uint8Array): GroupMemberRef {
  return fromGroupMemberRefCborValue(decode(bytes));
}

export function toProjectTaskRefCborValue(v: ProjectTaskRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("task_id", v.taskId);
  csilMap.set("project_id", v.projectId);
  return csilMap;
}

export function fromProjectTaskRefCborValue(value: CborValue): ProjectTaskRef {
  return {
    projectId: asString(requireKey(value, "project_id")),
    taskId: asString(requireKey(value, "task_id")),
  };
}

export function toProjectTaskRefCbor(v: ProjectTaskRef): Uint8Array {
  return encodeValue(toProjectTaskRefCborValue(v));
}

export function fromProjectTaskRefCbor(bytes: Uint8Array): ProjectTaskRef {
  return fromProjectTaskRefCborValue(decode(bytes));
}

export function toProjectTaskOrderRequestCborValue(v: ProjectTaskOrderRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("task_id", v.taskId);
  csilMap.set("position", v.position);
  csilMap.set("project_id", v.projectId);
  return csilMap;
}

export function fromProjectTaskOrderRequestCborValue(value: CborValue): ProjectTaskOrderRequest {
  return {
    projectId: asString(requireKey(value, "project_id")),
    taskId: asString(requireKey(value, "task_id")),
    position: asNumber(requireKey(value, "position")),
  };
}

export function toProjectTaskOrderRequestCbor(v: ProjectTaskOrderRequest): Uint8Array {
  return encodeValue(toProjectTaskOrderRequestCborValue(v));
}

export function fromProjectTaskOrderRequestCbor(bytes: Uint8Array): ProjectTaskOrderRequest {
  return fromProjectTaskOrderRequestCborValue(decode(bytes));
}

export function toProjectMemberRefCborValue(v: ProjectMemberRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("member_id", v.memberId);
  csilMap.set("project_id", v.projectId);
  return csilMap;
}

export function fromProjectMemberRefCborValue(value: CborValue): ProjectMemberRef {
  return {
    projectId: asString(requireKey(value, "project_id")),
    memberId: asString(requireKey(value, "member_id")),
  };
}

export function toProjectMemberRefCbor(v: ProjectMemberRef): Uint8Array {
  return encodeValue(toProjectMemberRefCborValue(v));
}

export function fromProjectMemberRefCbor(bytes: Uint8Array): ProjectMemberRef {
  return fromProjectMemberRefCborValue(decode(bytes));
}

export function toProjectOwnerRefCborValue(v: ProjectOwnerRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("member_id", v.memberId);
  csilMap.set("project_id", v.projectId);
  return csilMap;
}

export function fromProjectOwnerRefCborValue(value: CborValue): ProjectOwnerRef {
  return {
    projectId: asString(requireKey(value, "project_id")),
    memberId: asString(requireKey(value, "member_id")),
  };
}

export function toProjectOwnerRefCbor(v: ProjectOwnerRef): Uint8Array {
  return encodeValue(toProjectOwnerRefCborValue(v));
}

export function fromProjectOwnerRefCbor(bytes: Uint8Array): ProjectOwnerRef {
  return fromProjectOwnerRefCborValue(decode(bytes));
}

export function toDependencyRefCborValue(v: DependencyRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("dependent_id", v.dependentId);
  csilMap.set("dependency_id", v.dependencyId);
  csilMap.set("dependent_type", v.dependentType);
  csilMap.set("dependency_type", v.dependencyType);
  return csilMap;
}

export function fromDependencyRefCborValue(value: CborValue): DependencyRef {
  return {
    dependentType: (asEnumMember(asString(requireKey(value, "dependent_type")), ["task", "project"]) as "task" | "project"),
    dependentId: asString(requireKey(value, "dependent_id")),
    dependencyType: (asEnumMember(asString(requireKey(value, "dependency_type")), ["task", "project"]) as "task" | "project"),
    dependencyId: asString(requireKey(value, "dependency_id")),
  };
}

export function toDependencyRefCbor(v: DependencyRef): Uint8Array {
  return encodeValue(toDependencyRefCborValue(v));
}

export function fromDependencyRefCbor(bytes: Uint8Array): DependencyRef {
  return fromDependencyRefCborValue(decode(bytes));
}

export function toDependencyTargetCborValue(v: DependencyTarget): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("id", v.id);
  csilMap.set("type", v.type);
  return csilMap;
}

export function fromDependencyTargetCborValue(value: CborValue): DependencyTarget {
  return {
    type: (asEnumMember(asString(requireKey(value, "type")), ["task", "project"]) as "task" | "project"),
    id: asString(requireKey(value, "id")),
  };
}

export function toDependencyTargetCbor(v: DependencyTarget): Uint8Array {
  return encodeValue(toDependencyTargetCborValue(v));
}

export function fromDependencyTargetCbor(bytes: Uint8Array): DependencyTarget {
  return fromDependencyTargetCborValue(decode(bytes));
}

export function toDependencyNodeCborValue(v: DependencyNode): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("id", v.id);
  csilMap.set("type", v.type);
  csilMap.set("title", v.title);
  if (v.status !== undefined) csilMap.set("status", v.status);
  return csilMap;
}

export function fromDependencyNodeCborValue(value: CborValue): DependencyNode {
  return {
    type: (asEnumMember(asString(requireKey(value, "type")), ["task", "project"]) as "task" | "project"),
    id: asString(requireKey(value, "id")),
    title: asString(requireKey(value, "title")),
    status: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "status")),
  };
}

export function toDependencyNodeCbor(v: DependencyNode): Uint8Array {
  return encodeValue(toDependencyNodeCborValue(v));
}

export function fromDependencyNodeCbor(bytes: Uint8Array): DependencyNode {
  return fromDependencyNodeCborValue(decode(bytes));
}

export function toDependencyGraphCborValue(v: DependencyGraph): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("dependents", v.dependents.map((csilE): CborValue => toDependencyNodeCborValue(csilE)));
  csilMap.set("dependencies", v.dependencies.map((csilE): CborValue => toDependencyNodeCborValue(csilE)));
  return csilMap;
}

export function fromDependencyGraphCborValue(value: CborValue): DependencyGraph {
  return {
    dependencies: asArray(requireKey(value, "dependencies")).map((csilE) => fromDependencyNodeCborValue(csilE)),
    dependents: asArray(requireKey(value, "dependents")).map((csilE) => fromDependencyNodeCborValue(csilE)),
  };
}

export function toDependencyGraphCbor(v: DependencyGraph): Uint8Array {
  return encodeValue(toDependencyGraphCborValue(v));
}

export function fromDependencyGraphCbor(bytes: Uint8Array): DependencyGraph {
  return fromDependencyGraphCborValue(decode(bytes));
}

export function toGrantCborValue(v: Grant): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("grantee_id", v.granteeId);
  csilMap.set("access_level", v.accessLevel);
  csilMap.set("grantee_type", v.granteeType);
  return csilMap;
}

export function fromGrantCborValue(value: CborValue): Grant {
  return {
    granteeType: (asEnumMember(asString(requireKey(value, "grantee_type")), ["member", "group"]) as "member" | "group"),
    granteeId: asString(requireKey(value, "grantee_id")),
    accessLevel: (asEnumMember(asString(requireKey(value, "access_level")), ["none", "read", "edit", "full"]) as "none" | "read" | "edit" | "full"),
  };
}

export function toGrantCbor(v: Grant): Uint8Array {
  return encodeValue(toGrantCborValue(v));
}

export function fromGrantCbor(bytes: Uint8Array): Grant {
  return fromGrantCborValue(decode(bytes));
}

export function toTaskGrantRefCborValue(v: TaskGrantRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("task_id", v.taskId);
  csilMap.set("grantee_id", v.granteeId);
  csilMap.set("grantee_type", v.granteeType);
  return csilMap;
}

export function fromTaskGrantRefCborValue(value: CborValue): TaskGrantRef {
  return {
    taskId: asString(requireKey(value, "task_id")),
    granteeType: (asEnumMember(asString(requireKey(value, "grantee_type")), ["member", "group"]) as "member" | "group"),
    granteeId: asString(requireKey(value, "grantee_id")),
  };
}

export function toTaskGrantRefCbor(v: TaskGrantRef): Uint8Array {
  return encodeValue(toTaskGrantRefCborValue(v));
}

export function fromTaskGrantRefCbor(bytes: Uint8Array): TaskGrantRef {
  return fromTaskGrantRefCborValue(decode(bytes));
}

export function toPutTaskGrantRequestCborValue(v: PutTaskGrantRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("task_id", v.taskId);
  csilMap.set("grantee_id", v.granteeId);
  csilMap.set("access_level", v.accessLevel);
  csilMap.set("grantee_type", v.granteeType);
  return csilMap;
}

export function fromPutTaskGrantRequestCborValue(value: CborValue): PutTaskGrantRequest {
  return {
    taskId: asString(requireKey(value, "task_id")),
    granteeType: (asEnumMember(asString(requireKey(value, "grantee_type")), ["member", "group"]) as "member" | "group"),
    granteeId: asString(requireKey(value, "grantee_id")),
    accessLevel: (asEnumMember(asString(requireKey(value, "access_level")), ["none", "read", "edit", "full"]) as "none" | "read" | "edit" | "full"),
  };
}

export function toPutTaskGrantRequestCbor(v: PutTaskGrantRequest): Uint8Array {
  return encodeValue(toPutTaskGrantRequestCborValue(v));
}

export function fromPutTaskGrantRequestCbor(bytes: Uint8Array): PutTaskGrantRequest {
  return fromPutTaskGrantRequestCborValue(decode(bytes));
}

export function toSetTaskVisibilityRequestCborValue(v: SetTaskVisibilityRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("task_id", v.taskId);
  csilMap.set("visibility", v.visibility);
  return csilMap;
}

export function fromSetTaskVisibilityRequestCborValue(value: CborValue): SetTaskVisibilityRequest {
  return {
    taskId: asString(requireKey(value, "task_id")),
    visibility: (asEnumMember(asString(requireKey(value, "visibility")), ["none", "read", "edit", "full"]) as "none" | "read" | "edit" | "full"),
  };
}

export function toSetTaskVisibilityRequestCbor(v: SetTaskVisibilityRequest): Uint8Array {
  return encodeValue(toSetTaskVisibilityRequestCborValue(v));
}

export function fromSetTaskVisibilityRequestCbor(bytes: Uint8Array): SetTaskVisibilityRequest {
  return fromSetTaskVisibilityRequestCborValue(decode(bytes));
}

export function toProjectGrantRefCborValue(v: ProjectGrantRef): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("grantee_id", v.granteeId);
  csilMap.set("project_id", v.projectId);
  csilMap.set("grantee_type", v.granteeType);
  return csilMap;
}

export function fromProjectGrantRefCborValue(value: CborValue): ProjectGrantRef {
  return {
    projectId: asString(requireKey(value, "project_id")),
    granteeType: (asEnumMember(asString(requireKey(value, "grantee_type")), ["member", "group"]) as "member" | "group"),
    granteeId: asString(requireKey(value, "grantee_id")),
  };
}

export function toProjectGrantRefCbor(v: ProjectGrantRef): Uint8Array {
  return encodeValue(toProjectGrantRefCborValue(v));
}

export function fromProjectGrantRefCbor(bytes: Uint8Array): ProjectGrantRef {
  return fromProjectGrantRefCborValue(decode(bytes));
}

export function toPutProjectGrantRequestCborValue(v: PutProjectGrantRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("grantee_id", v.granteeId);
  csilMap.set("project_id", v.projectId);
  csilMap.set("access_level", v.accessLevel);
  csilMap.set("grantee_type", v.granteeType);
  return csilMap;
}

export function fromPutProjectGrantRequestCborValue(value: CborValue): PutProjectGrantRequest {
  return {
    projectId: asString(requireKey(value, "project_id")),
    granteeType: (asEnumMember(asString(requireKey(value, "grantee_type")), ["member", "group"]) as "member" | "group"),
    granteeId: asString(requireKey(value, "grantee_id")),
    accessLevel: (asEnumMember(asString(requireKey(value, "access_level")), ["none", "read", "edit", "full"]) as "none" | "read" | "edit" | "full"),
  };
}

export function toPutProjectGrantRequestCbor(v: PutProjectGrantRequest): Uint8Array {
  return encodeValue(toPutProjectGrantRequestCborValue(v));
}

export function fromPutProjectGrantRequestCbor(bytes: Uint8Array): PutProjectGrantRequest {
  return fromPutProjectGrantRequestCborValue(decode(bytes));
}

export function toSetProjectVisibilityRequestCborValue(v: SetProjectVisibilityRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("project_id", v.projectId);
  csilMap.set("visibility", v.visibility);
  return csilMap;
}

export function fromSetProjectVisibilityRequestCborValue(value: CborValue): SetProjectVisibilityRequest {
  return {
    projectId: asString(requireKey(value, "project_id")),
    visibility: (asEnumMember(asString(requireKey(value, "visibility")), ["none", "read", "edit", "full"]) as "none" | "read" | "edit" | "full"),
  };
}

export function toSetProjectVisibilityRequestCbor(v: SetProjectVisibilityRequest): Uint8Array {
  return encodeValue(toSetProjectVisibilityRequestCborValue(v));
}

export function fromSetProjectVisibilityRequestCbor(bytes: Uint8Array): SetProjectVisibilityRequest {
  return fromSetProjectVisibilityRequestCborValue(decode(bytes));
}

export function toEffectiveSettingsCborValue(v: EffectiveSettings): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.bugReportsEnabled !== undefined) csilMap.set("bug_reports_enabled", v.bugReportsEnabled);
  if (v.bugReportsProjectId !== undefined) csilMap.set("bug_reports_project_id", v.bugReportsProjectId);
  if (v.sessionLifetimeHours !== undefined) csilMap.set("session_lifetime_hours", v.sessionLifetimeHours);
  if (v.defaultProjectVisibility !== undefined) csilMap.set("default_project_visibility", v.defaultProjectVisibility);
  return csilMap;
}

export function fromEffectiveSettingsCborValue(value: CborValue): EffectiveSettings {
  return {
    bugReportsEnabled: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asBool(csilV))(mapGet(value, "bug_reports_enabled")),
    bugReportsProjectId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "bug_reports_project_id")),
    defaultProjectVisibility: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : (asEnumMember(asString(csilV), ["none", "read", "edit", "full"]) as "none" | "read" | "edit" | "full"))(mapGet(value, "default_project_visibility")),
    sessionLifetimeHours: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "session_lifetime_hours")),
  };
}

export function toEffectiveSettingsCbor(v: EffectiveSettings): Uint8Array {
  return encodeValue(toEffectiveSettingsCborValue(v));
}

export function fromEffectiveSettingsCbor(bytes: Uint8Array): EffectiveSettings {
  return fromEffectiveSettingsCborValue(decode(bytes));
}

export function toUpdateSettingsRequestCborValue(v: UpdateSettingsRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("house_id", v.houseId);
  csilMap.set("settings", toEffectiveSettingsCborValue(v.settings));
  return csilMap;
}

export function fromUpdateSettingsRequestCborValue(value: CborValue): UpdateSettingsRequest {
  return {
    houseId: asString(requireKey(value, "house_id")),
    settings: fromEffectiveSettingsCborValue(requireKey(value, "settings")),
  };
}

export function toUpdateSettingsRequestCbor(v: UpdateSettingsRequest): Uint8Array {
  return encodeValue(toUpdateSettingsRequestCborValue(v));
}

export function fromUpdateSettingsRequestCbor(bytes: Uint8Array): UpdateSettingsRequest {
  return fromUpdateSettingsRequestCborValue(decode(bytes));
}

export function toBugReportRequestCborValue(v: BugReportRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("title", v.title);
  csilMap.set("house_id", v.houseId);
  if (v.description !== undefined) csilMap.set("description", v.description);
  return csilMap;
}

export function fromBugReportRequestCborValue(value: CborValue): BugReportRequest {
  return {
    houseId: asString(requireKey(value, "house_id")),
    title: asString(requireKey(value, "title")),
    description: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "description")),
  };
}

export function toBugReportRequestCbor(v: BugReportRequest): Uint8Array {
  return encodeValue(toBugReportRequestCborValue(v));
}

export function fromBugReportRequestCbor(bytes: Uint8Array): BugReportRequest {
  return fromBugReportRequestCborValue(decode(bytes));
}

export function toServiceErrorCborValue(v: ServiceError): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("code", v.code);
  csilMap.set("message", v.message);
  return csilMap;
}

export function fromServiceErrorCborValue(value: CborValue): ServiceError {
  return {
    code: asNumber(requireKey(value, "code")),
    message: asString(requireKey(value, "message")),
  };
}

export function toServiceErrorCbor(v: ServiceError): Uint8Array {
  return encodeValue(toServiceErrorCborValue(v));
}

export function fromServiceErrorCbor(bytes: Uint8Array): ServiceError {
  return fromServiceErrorCborValue(decode(bytes));
}

export function toCalendarSubscriptionCborValue(v: CalendarSubscription): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("enabled", v.enabled);
  csilMap.set("subject_member_id", v.subjectMemberId);
  return csilMap;
}

export function fromCalendarSubscriptionCborValue(value: CborValue): CalendarSubscription {
  return {
    subjectMemberId: asString(requireKey(value, "subject_member_id")),
    enabled: asBool(requireKey(value, "enabled")),
  };
}

export function toCalendarSubscriptionCbor(v: CalendarSubscription): Uint8Array {
  return encodeValue(toCalendarSubscriptionCborValue(v));
}

export function fromCalendarSubscriptionCbor(bytes: Uint8Array): CalendarSubscription {
  return fromCalendarSubscriptionCborValue(decode(bytes));
}

export function toCalendarViewCborValue(v: CalendarView): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("house_id", v.houseId);
  if (v.subscriptions !== undefined) csilMap.set("subscriptions", v.subscriptions.map((csilE): CborValue => toCalendarSubscriptionCborValue(csilE)));
  csilMap.set("viewer_member_id", v.viewerMemberId);
  return csilMap;
}

export function fromCalendarViewCborValue(value: CborValue): CalendarView {
  return {
    houseId: asString(requireKey(value, "house_id")),
    viewerMemberId: asString(requireKey(value, "viewer_member_id")),
    subscriptions: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asArray(csilV).map((csilE) => fromCalendarSubscriptionCborValue(csilE)))(mapGet(value, "subscriptions")),
  };
}

export function toCalendarViewCbor(v: CalendarView): Uint8Array {
  return encodeValue(toCalendarViewCborValue(v));
}

export function fromCalendarViewCbor(bytes: Uint8Array): CalendarView {
  return fromCalendarViewCborValue(decode(bytes));
}

export function toAuditEntryCborValue(v: AuditEntry): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.after !== undefined) csilMap.set("after", v.after);
  csilMap.set("action", v.action);
  if (v.before !== undefined) csilMap.set("before", v.before);
  if (v.detail !== undefined) csilMap.set("detail", v.detail);
  csilMap.set("method", v.method);
  csilMap.set("outcome", v.outcome);
  csilMap.set("audit_id", v.auditId);
  if (v.houseId !== undefined) csilMap.set("house_id", v.houseId);
  csilMap.set("created_at", v.createdAt);
  if (v.resourceId !== undefined) csilMap.set("resource_id", v.resourceId);
  csilMap.set("actor_domain", v.actorDomain);
  csilMap.set("service_name", v.serviceName);
  csilMap.set("actor_user_id", v.actorUserId);
  if (v.resourceType !== undefined) csilMap.set("resource_type", v.resourceType);
  if (v.actorMemberId !== undefined) csilMap.set("actor_member_id", v.actorMemberId);
  return csilMap;
}

export function fromAuditEntryCborValue(value: CborValue): AuditEntry {
  return {
    auditId: asString(requireKey(value, "audit_id")),
    houseId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "house_id")),
    actorMemberId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "actor_member_id")),
    actorDomain: asString(requireKey(value, "actor_domain")),
    actorUserId: asString(requireKey(value, "actor_user_id")),
    serviceName: asString(requireKey(value, "service_name")),
    method: asString(requireKey(value, "method")),
    action: asString(requireKey(value, "action")),
    resourceType: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "resource_type")),
    resourceId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "resource_id")),
    outcome: asString(requireKey(value, "outcome")),
    before: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "before")),
    after: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "after")),
    detail: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "detail")),
    createdAt: asString(requireKey(value, "created_at")),
  };
}

export function toAuditEntryCbor(v: AuditEntry): Uint8Array {
  return encodeValue(toAuditEntryCborValue(v));
}

export function fromAuditEntryCbor(bytes: Uint8Array): AuditEntry {
  return fromAuditEntryCborValue(decode(bytes));
}

export function toAuditQueryCborValue(v: AuditQuery): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.limit !== undefined) csilMap.set("limit", v.limit);
  if (v.since !== undefined) csilMap.set("since", v.since);
  if (v.until !== undefined) csilMap.set("until", v.until);
  if (v.action !== undefined) csilMap.set("action", v.action);
  if (v.cursor !== undefined) csilMap.set("cursor", v.cursor);
  csilMap.set("house_id", v.houseId);
  if (v.resourceType !== undefined) csilMap.set("resource_type", v.resourceType);
  if (v.actorMemberId !== undefined) csilMap.set("actor_member_id", v.actorMemberId);
  return csilMap;
}

export function fromAuditQueryCborValue(value: CborValue): AuditQuery {
  return {
    houseId: asString(requireKey(value, "house_id")),
    actorMemberId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "actor_member_id")),
    resourceType: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "resource_type")),
    action: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "action")),
    since: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "since")),
    until: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "until")),
    cursor: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "cursor")),
    limit: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asNumber(csilV))(mapGet(value, "limit")),
  };
}

export function toAuditQueryCbor(v: AuditQuery): Uint8Array {
  return encodeValue(toAuditQueryCborValue(v));
}

export function fromAuditQueryCbor(bytes: Uint8Array): AuditQuery {
  return fromAuditQueryCborValue(decode(bytes));
}

export function toAuditPageCborValue(v: AuditPage): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("entries", v.entries.map((csilE): CborValue => toAuditEntryCborValue(csilE)));
  if (v.nextCursor !== undefined) csilMap.set("next_cursor", v.nextCursor);
  return csilMap;
}

export function fromAuditPageCborValue(value: CborValue): AuditPage {
  return {
    entries: asArray(requireKey(value, "entries")).map((csilE) => fromAuditEntryCborValue(csilE)),
    nextCursor: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "next_cursor")),
  };
}

export function toAuditPageCbor(v: AuditPage): Uint8Array {
  return encodeValue(toAuditPageCborValue(v));
}

export function fromAuditPageCbor(bytes: Uint8Array): AuditPage {
  return fromAuditPageCborValue(decode(bytes));
}

export function toTrashItemCborValue(v: TrashItem): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  if (v.title !== undefined) csilMap.set("title", v.title);
  csilMap.set("house_id", v.houseId);
  csilMap.set("deleted_at", v.deletedAt);
  csilMap.set("resource_id", v.resourceId);
  csilMap.set("deleted_op_id", v.deletedOpId);
  csilMap.set("resource_type", v.resourceType);
  if (v.deletedByMemberId !== undefined) csilMap.set("deleted_by_member_id", v.deletedByMemberId);
  return csilMap;
}

export function fromTrashItemCborValue(value: CborValue): TrashItem {
  return {
    resourceType: asString(requireKey(value, "resource_type")),
    resourceId: asString(requireKey(value, "resource_id")),
    houseId: asString(requireKey(value, "house_id")),
    title: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "title")),
    deletedAt: asString(requireKey(value, "deleted_at")),
    deletedByMemberId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "deleted_by_member_id")),
    deletedOpId: asString(requireKey(value, "deleted_op_id")),
  };
}

export function toTrashItemCbor(v: TrashItem): Uint8Array {
  return encodeValue(toTrashItemCborValue(v));
}

export function fromTrashItemCbor(bytes: Uint8Array): TrashItem {
  return fromTrashItemCborValue(decode(bytes));
}

export function toTrashPageCborValue(v: TrashPage): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("items", v.items.map((csilE): CborValue => toTrashItemCborValue(csilE)));
  if (v.nextCursor !== undefined) csilMap.set("next_cursor", v.nextCursor);
  return csilMap;
}

export function fromTrashPageCborValue(value: CborValue): TrashPage {
  return {
    items: asArray(requireKey(value, "items")).map((csilE) => fromTrashItemCborValue(csilE)),
    nextCursor: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "next_cursor")),
  };
}

export function toTrashPageCbor(v: TrashPage): Uint8Array {
  return encodeValue(toTrashPageCborValue(v));
}

export function fromTrashPageCbor(bytes: Uint8Array): TrashPage {
  return fromTrashPageCborValue(decode(bytes));
}

export function toRestoreRequestCborValue(v: RestoreRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("house_id", v.houseId);
  if (v.resourceId !== undefined) csilMap.set("resource_id", v.resourceId);
  if (v.deletedOpId !== undefined) csilMap.set("deleted_op_id", v.deletedOpId);
  if (v.resourceType !== undefined) csilMap.set("resource_type", v.resourceType);
  return csilMap;
}

export function fromRestoreRequestCborValue(value: CborValue): RestoreRequest {
  return {
    houseId: asString(requireKey(value, "house_id")),
    deletedOpId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "deleted_op_id")),
    resourceType: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "resource_type")),
    resourceId: ((csilV: CborValue | undefined) => csilV === undefined ? undefined : asString(csilV))(mapGet(value, "resource_id")),
  };
}

export function toRestoreRequestCbor(v: RestoreRequest): Uint8Array {
  return encodeValue(toRestoreRequestCborValue(v));
}

export function fromRestoreRequestCbor(bytes: Uint8Array): RestoreRequest {
  return fromRestoreRequestCborValue(decode(bytes));
}

export function toPurgeRequestCborValue(v: PurgeRequest): CborValue {
  const csilMap = new Map<CborValue, CborValue>();
  csilMap.set("house_id", v.houseId);
  csilMap.set("resource_id", v.resourceId);
  csilMap.set("resource_type", v.resourceType);
  return csilMap;
}

export function fromPurgeRequestCborValue(value: CborValue): PurgeRequest {
  return {
    houseId: asString(requireKey(value, "house_id")),
    resourceType: asString(requireKey(value, "resource_type")),
    resourceId: asString(requireKey(value, "resource_id")),
  };
}

export function toPurgeRequestCbor(v: PurgeRequest): Uint8Array {
  return encodeValue(toPurgeRequestCborValue(v));
}

export function fromPurgeRequestCbor(bytes: Uint8Array): PurgeRequest {
  return fromPurgeRequestCborValue(decode(bytes));
}

